import Button from '@mui/material/Button';
import React from 'react';

interface CancelButtonProps {
  className?: string;
  label?: string;
  onClick: () => void;
}

function CancelButton({ className, label, onClick }: CancelButtonProps): JSX.Element {
  return (
    <Button variant='contained' onClick={onClick} className={className}>
      {label}
    </Button>
  );
}

CancelButton.defaultProps = {
  className: undefined,
  label: 'Cancel',
};

export default CancelButton;
